import React from 'react';


import fetch from '../../../fetch';


/**
 * @method getProjectBaseById
 * @param {int} data
 * @return {promise}
 */
 const getProjectBaseById = (id) => {
	return fetch.post('ky/achievement/researchReport/getBaseById/'+ id)
}


const getProjectMemberById = (id) => {
	return fetch.post('ky/achievement/researchReport/getMemberById/'+ id)
}

const getProjectByResultId = (id) => {
	return fetch.post('ky/achievement/researchReport/getProjectByResultId/'+ id)
}


export default {
	getProjectBaseById,
	getProjectMemberById,
	getProjectByResultId,
}